const initialState = {
    fanLoading: false,
    momentoLoading: false,
    fanRequests: [],
    fanGallery: [],
    allAthletes: [],
    fanBoughtGallery: [],
    lastFanGalleryDocument: null,
    hasMoreFanGallery: true,
};

export default function fanMomentoReducer(
    state = initialState,
    { type, payload }
) {
    switch (type) {
        case "MY_REQUESTS":
            return {
                ...state,
                fanRequests: payload,
            };
        case "Loading":
            return {
                ...state,
                fanLoading: payload,
            };
        case "FAN_Loading":
            return {
                ...state,
                momentoLoading: payload,
            };
        case "FAN_GALLERY":
            return {
                ...state,
                fanGallery: payload.data,
                lastFanGalleryDocument: payload.lastDocument,
                hasMoreFanGallery: payload.hasMore,
            };
        case "FAN_GALLERY_MORE":
            return {
                ...state,
                fanGallery: [...state.fanGallery, ...payload.data],
                lastFanGalleryDocument: payload.lastDocument,
                hasMoreFanGallery: payload.hasMore,
            };
        case "FAN_BOUGHT_GALLERY":
            return {
                ...state,
                fanBoughtGallery: payload,
            };
        case "ALL_USERS":
            return {
                ...state,
                allAthletes: payload,
            };
        default:
            return { ...state };
    }
}
